const careQualityMessages = {
  CARE_QUALITY_PAGE: {
    TITLE: 'Care Gaps',
    SUB_TITLE:
      'Care Gaps identify missing recommended preventive care services to be addressed and are based on HEDIS measures by CMS.',
    CARDS: {
      ELIGIBLE_MEASURES: 'Eligible Measures',
      TOTAL_ENROLLED: 'Total Enrolled',
      NON_COMPLAINT: 'Non-Compliant',
      ELIGIBLE_POPULATION: 'Eligible Population',
      TOTAL_POPULATION: 'Total Population',
      CARE_QUALITY_DISTRIBUTION: {
        TITLE: 'Care Gaps Distribution',
        SUBTITLE:
          'This table shows benchmark performance of each measure with respect to national performance',
      },
      GUIDE_LINK: {
        'Breast Cancer Screening':
          'https://docs.google.com/document/d/1Vjj_8USFJYUfZfxlt9mYLNzIj_9zTNPqvGRIc-ywDes/edit?usp=drive_link',
        'Cervical Cancer Screening':
          'https://docs.google.com/document/d/1pq8_Wa8oieQGGG0aQGcsxiMbqrzALpnYzwLIH5jQ8tc/edit?usp=drive_link',
        'Child And Adolescent Well-Care Visits':
          'https://docs.google.com/document/d/12FabKmsgTaA9qwlFvZybx9tYFbuxqTGSFPm8tuJfa78/edit?usp=drive_link',
        'Colorectal Cancer Screening':
          'https://docs.google.com/document/d/1IkmqVD1zPFSiPkB3oUB5HiKF9epA6K-_68I5ezNmHzI/edit?usp=drive_link',
        'Immunizations For Adolescents':
          'https://docs.google.com/document/d/1xDDEc9jz0DZt4_Arwgogs_OSiFK_HvwWMQHPZBQkKOA/edit?usp=drive_link',
        'Lead Screening In Children':
          'https://docs.google.com/document/d/1SueolVJl43wI0GLnlhy3srX6zqvJbXbzQkw02_WP8RU/edit?usp=drive_link',
        'Weight Assessment & Counseling for Children and Adolescents':
          'https://docs.google.com/document/d/19eMdrm9W-VYzAiFbiOJ3cVC5hdebo2-UFKiMdWycPsU/edit?usp=drive_link',
      },

      EXPERIENCE_FILTER: [
        'Prevention And Screening',
        'Diabetes',
        'Cardiovascular Conditions',
      ],
    },
    COHORT_DETAILS: {
      TITLE: 'Cohort Details',
      SUBTITLE:
        'Select the properties that you would like to apply to current data',
    },
  },
};

export default careQualityMessages;
